import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Mail, Phone, Globe, MapPin, Building } from 'lucide-react';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Building className="h-6 w-6 text-blue-600" />
              Contact Us
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Abbey 5 Star Ltd</h2>
                <p className="text-muted-foreground mb-6">
                  For any questions, support requests, or business inquiries, please don't hesitate to contact us.
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {/* Contact Methods */}
                <div className="space-y-4">
                  <h3 className="font-medium text-slate-900">Get in Touch</h3>
                  
                  <a 
                    href="mailto:info@abbey5star.co.uk" 
                    className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors"
                  >
                    <div className="p-2 bg-blue-100 rounded-full">
                      <Mail className="h-5 w-5 text-blue-600" />
                    </div>
                    <div>
                      <p className="font-medium text-slate-900">Email</p>
                      <p className="text-sm text-blue-600">info@abbey5star.co.uk</p>
                    </div>
                  </a>

                  <a 
                    href="tel:+441onal-number" 
                    className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors"
                  >
                    <div className="p-2 bg-green-100 rounded-full">
                      <Phone className="h-5 w-5 text-green-600" />
                    </div>
                    <div>
                      <p className="font-medium text-slate-900">Phone</p>
                      <p className="text-sm text-muted-foreground">Contact us for phone support</p>
                    </div>
                  </a>

                  <a 
                    href="https://www.abbey5star.co.uk" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors"
                  >
                    <div className="p-2 bg-purple-100 rounded-full">
                      <Globe className="h-5 w-5 text-purple-600" />
                    </div>
                    <div>
                      <p className="font-medium text-slate-900">Website</p>
                      <p className="text-sm text-blue-600">www.abbey5star.co.uk</p>
                    </div>
                  </a>
                </div>

                {/* Office Info */}
                <div className="space-y-4">
                  <h3 className="font-medium text-slate-900">Our Offices</h3>
                  
                  <div className="p-4 bg-slate-50 rounded-lg">
                    <div className="flex items-start gap-3">
                      <MapPin className="h-5 w-5 text-slate-500 mt-0.5" />
                      <div>
                        <p className="font-medium text-slate-900">United Kingdom</p>
                        <p className="text-sm text-muted-foreground">
                          Serving clients across the UK
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="p-4 bg-slate-50 rounded-lg">
                    <div className="flex items-start gap-3">
                      <MapPin className="h-5 w-5 text-slate-500 mt-0.5" />
                      <div>
                        <p className="font-medium text-slate-900">United Arab Emirates</p>
                        <p className="text-sm text-muted-foreground">
                          Serving clients across the UAE
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-4 bg-blue-50 border border-blue-100 rounded-lg">
                <h3 className="font-medium text-blue-900 mb-2">Support Hours</h3>
                <p className="text-sm text-blue-800">
                  Monday - Friday: 9:00 AM - 5:00 PM (GMT)<br />
                  We aim to respond to all inquiries within 24 business hours.
                </p>
              </div>

              <div className="text-center pt-6 border-t">
                <p className="text-sm text-muted-foreground">
                  <strong>Abbey 5 Star Ltd</strong> • Registered in England and Wales
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
